var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFeature1 = function SvgFeature1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 566.385,
    height: 372.362,
    viewBox: "0 0 566.385 372.362",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2",
    "data-name": "Clip 2",
    d: "M0,0H6V6.017H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(0 -1.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2082",
    "data-name": "Group 2082",
    transform: "translate(0 1.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(203.038 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_2-2",
    "data-name": "Clip 2",
    d: "M0,0H6V6.017H0Z",
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(0 0)",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 8.143)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_6",
    "data-name": "Fill 6",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 8.143)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_8",
    "data-name": "Fill 8",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 8.143)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_10",
    "data-name": "Fill 10",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 8.143)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_12",
    "data-name": "Fill 12",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 8.143)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_14",
    "data-name": "Fill 14",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 8.143)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_16",
    "data-name": "Fill 16",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_18",
    "data-name": "Fill 18",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_20",
    "data-name": "Fill 20",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_22",
    "data-name": "Fill 22",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_24",
    "data-name": "Fill 24",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_26",
    "data-name": "Fill 26",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_28",
    "data-name": "Fill 28",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_30",
    "data-name": "Fill 30",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_32",
    "data-name": "Fill 32",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_34",
    "data-name": "Fill 34",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_36",
    "data-name": "Fill 36",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 16.281)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_38",
    "data-name": "Fill 38",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_40",
    "data-name": "Fill 40",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_42",
    "data-name": "Fill 42",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_44",
    "data-name": "Fill 44",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_46",
    "data-name": "Fill 46",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_48",
    "data-name": "Fill 48",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_50",
    "data-name": "Fill 50",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_52",
    "data-name": "Fill 52",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_54",
    "data-name": "Fill 54",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_56",
    "data-name": "Fill 56",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_58",
    "data-name": "Fill 58",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_60",
    "data-name": "Fill 60",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_62",
    "data-name": "Fill 62",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_64",
    "data-name": "Fill 64",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(235.521 24.424)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_66",
    "data-name": "Fill 66",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_68",
    "data-name": "Fill 68",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_70",
    "data-name": "Fill 70",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_72",
    "data-name": "Fill 72",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_74",
    "data-name": "Fill 74",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_76",
    "data-name": "Fill 76",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_78",
    "data-name": "Fill 78",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_80",
    "data-name": "Fill 80",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_82",
    "data-name": "Fill 82",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_84",
    "data-name": "Fill 84",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_86",
    "data-name": "Fill 86",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_88",
    "data-name": "Fill 88",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_90",
    "data-name": "Fill 90",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_92",
    "data-name": "Fill 92",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(235.521 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_94",
    "data-name": "Fill 94",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 32.568)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_96",
    "data-name": "Fill 96",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_98",
    "data-name": "Fill 98",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_100",
    "data-name": "Fill 100",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_102",
    "data-name": "Fill 102",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_104",
    "data-name": "Fill 104",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_106",
    "data-name": "Fill 106",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_108",
    "data-name": "Fill 108",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_110",
    "data-name": "Fill 110",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_112",
    "data-name": "Fill 112",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_114",
    "data-name": "Fill 114",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_116",
    "data-name": "Fill 116",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_118",
    "data-name": "Fill 118",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_120",
    "data-name": "Fill 120",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_122",
    "data-name": "Fill 122",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_124",
    "data-name": "Fill 124",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_126",
    "data-name": "Fill 126",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_128",
    "data-name": "Fill 128",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_130",
    "data-name": "Fill 130",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_132",
    "data-name": "Fill 132",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 40.705)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_134",
    "data-name": "Fill 134",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_136",
    "data-name": "Fill 136",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_138",
    "data-name": "Fill 138",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_140",
    "data-name": "Fill 140",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_142",
    "data-name": "Fill 142",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_144",
    "data-name": "Fill 144",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_146",
    "data-name": "Fill 146",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_148",
    "data-name": "Fill 148",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_150",
    "data-name": "Fill 150",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_152",
    "data-name": "Fill 152",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_154",
    "data-name": "Fill 154",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_156",
    "data-name": "Fill 156",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_158",
    "data-name": "Fill 158",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_160",
    "data-name": "Fill 160",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_162",
    "data-name": "Fill 162",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_164",
    "data-name": "Fill 164",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_166",
    "data-name": "Fill 166",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 48.849)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_168",
    "data-name": "Fill 168",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_170",
    "data-name": "Fill 170",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_172",
    "data-name": "Fill 172",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_174",
    "data-name": "Fill 174",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_176",
    "data-name": "Fill 176",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_178",
    "data-name": "Fill 178",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_180",
    "data-name": "Fill 180",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_182",
    "data-name": "Fill 182",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_184",
    "data-name": "Fill 184",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_186",
    "data-name": "Fill 186",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_188",
    "data-name": "Fill 188",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_190",
    "data-name": "Fill 190",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_192",
    "data-name": "Fill 192",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_194",
    "data-name": "Fill 194",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_196",
    "data-name": "Fill 196",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_198",
    "data-name": "Fill 198",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_200",
    "data-name": "Fill 200",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 56.987)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_202",
    "data-name": "Fill 202",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_204",
    "data-name": "Fill 204",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_206",
    "data-name": "Fill 206",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_208",
    "data-name": "Fill 208",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_210",
    "data-name": "Fill 210",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_212",
    "data-name": "Fill 212",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_214",
    "data-name": "Fill 214",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_216",
    "data-name": "Fill 216",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_218",
    "data-name": "Fill 218",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_220",
    "data-name": "Fill 220",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_222",
    "data-name": "Fill 222",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_224",
    "data-name": "Fill 224",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_226",
    "data-name": "Fill 226",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_228",
    "data-name": "Fill 228",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_230",
    "data-name": "Fill 230",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_232",
    "data-name": "Fill 232",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_234",
    "data-name": "Fill 234",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 65.13)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_236",
    "data-name": "Fill 236",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_238",
    "data-name": "Fill 238",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_240",
    "data-name": "Fill 240",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_242",
    "data-name": "Fill 242",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_244",
    "data-name": "Fill 244",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_246",
    "data-name": "Fill 246",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_248",
    "data-name": "Fill 248",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_250",
    "data-name": "Fill 250",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_252",
    "data-name": "Fill 252",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_254",
    "data-name": "Fill 254",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_256",
    "data-name": "Fill 256",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_258",
    "data-name": "Fill 258",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_260",
    "data-name": "Fill 260",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_262",
    "data-name": "Fill 262",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_264",
    "data-name": "Fill 264",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_266",
    "data-name": "Fill 266",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_268",
    "data-name": "Fill 268",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_270",
    "data-name": "Fill 270",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_272",
    "data-name": "Fill 272",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_274",
    "data-name": "Fill 274",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 73.274)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_276",
    "data-name": "Fill 276",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_278",
    "data-name": "Fill 278",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_280",
    "data-name": "Fill 280",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_282",
    "data-name": "Fill 282",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_284",
    "data-name": "Fill 284",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_286",
    "data-name": "Fill 286",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_288",
    "data-name": "Fill 288",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_290",
    "data-name": "Fill 290",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_292",
    "data-name": "Fill 292",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_294",
    "data-name": "Fill 294",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_296",
    "data-name": "Fill 296",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_298",
    "data-name": "Fill 298",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_300",
    "data-name": "Fill 300",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_302",
    "data-name": "Fill 302",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_304",
    "data-name": "Fill 304",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_306",
    "data-name": "Fill 306",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_308",
    "data-name": "Fill 308",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 81.411)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_310",
    "data-name": "Fill 310",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_312",
    "data-name": "Fill 312",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_314",
    "data-name": "Fill 314",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_316",
    "data-name": "Fill 316",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_318",
    "data-name": "Fill 318",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_320",
    "data-name": "Fill 320",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_322",
    "data-name": "Fill 322",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_324",
    "data-name": "Fill 324",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_326",
    "data-name": "Fill 326",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_328",
    "data-name": "Fill 328",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_330",
    "data-name": "Fill 330",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_332",
    "data-name": "Fill 332",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_334",
    "data-name": "Fill 334",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_336",
    "data-name": "Fill 336",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_338",
    "data-name": "Fill 338",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_340",
    "data-name": "Fill 340",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_342",
    "data-name": "Fill 342",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_344",
    "data-name": "Fill 344",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_346",
    "data-name": "Fill 346",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 89.555)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_348",
    "data-name": "Fill 348",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_350",
    "data-name": "Fill 350",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_352",
    "data-name": "Fill 352",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_354",
    "data-name": "Fill 354",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_356",
    "data-name": "Fill 356",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_358",
    "data-name": "Fill 358",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_360",
    "data-name": "Fill 360",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_362",
    "data-name": "Fill 362",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_364",
    "data-name": "Fill 364",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_366",
    "data-name": "Fill 366",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_368",
    "data-name": "Fill 368",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_370",
    "data-name": "Fill 370",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_372",
    "data-name": "Fill 372",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_374",
    "data-name": "Fill 374",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_376",
    "data-name": "Fill 376",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_378",
    "data-name": "Fill 378",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_380",
    "data-name": "Fill 380",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_382",
    "data-name": "Fill 382",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_384",
    "data-name": "Fill 384",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_386",
    "data-name": "Fill 386",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_388",
    "data-name": "Fill 388",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_390",
    "data-name": "Fill 390",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_392",
    "data-name": "Fill 392",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_394",
    "data-name": "Fill 394",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_396",
    "data-name": "Fill 396",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_398",
    "data-name": "Fill 398",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_400",
    "data-name": "Fill 400",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_402",
    "data-name": "Fill 402",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_404",
    "data-name": "Fill 404",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 97.692)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    transform: "translate(0 105.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_407-2",
    "data-name": "Clip 407",
    d: "M0,0H6V6.017H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_408-2",
    "data-name": "Group 408",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_406",
    "data-name": "Fill 406",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(0)",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_409",
    "data-name": "Fill 409",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(8.124 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_411",
    "data-name": "Fill 411",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(16.242 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_413",
    "data-name": "Fill 413",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(24.366 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_415",
    "data-name": "Fill 415",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_417",
    "data-name": "Fill 417",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_419",
    "data-name": "Fill 419",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_421",
    "data-name": "Fill 421",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_423",
    "data-name": "Fill 423",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_425",
    "data-name": "Fill 425",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_427",
    "data-name": "Fill 427",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_429",
    "data-name": "Fill 429",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_431",
    "data-name": "Fill 431",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_433",
    "data-name": "Fill 433",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_435",
    "data-name": "Fill 435",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_437",
    "data-name": "Fill 437",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_439",
    "data-name": "Fill 439",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_441",
    "data-name": "Fill 441",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(219.28 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_443",
    "data-name": "Fill 443",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_445",
    "data-name": "Fill 445",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_447",
    "data-name": "Fill 447",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_449",
    "data-name": "Fill 449",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_451",
    "data-name": "Fill 451",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_453",
    "data-name": "Fill 453",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_455",
    "data-name": "Fill 455",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_457",
    "data-name": "Fill 457",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_459",
    "data-name": "Fill 459",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_461",
    "data-name": "Fill 461",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_463",
    "data-name": "Fill 463",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_465",
    "data-name": "Fill 465",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_467",
    "data-name": "Fill 467",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_469",
    "data-name": "Fill 469",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_471",
    "data-name": "Fill 471",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_473",
    "data-name": "Fill 473",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_475",
    "data-name": "Fill 475",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_477",
    "data-name": "Fill 477",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_479",
    "data-name": "Fill 479",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(503.527 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_481",
    "data-name": "Fill 481",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(511.651 105.836)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485",
    transform: "translate(0 113.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_484-2",
    "data-name": "Clip 484",
    d: "M0,0H6V6.017H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_485-2",
    "data-name": "Group 485",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_483",
    "data-name": "Fill 483",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(0)",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_486",
    "data-name": "Fill 486",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(8.124 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_488",
    "data-name": "Fill 488",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(16.242 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_490",
    "data-name": "Fill 490",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(24.366 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_492",
    "data-name": "Fill 492",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(32.489 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_494",
    "data-name": "Fill 494",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(40.607 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_496",
    "data-name": "Fill 496",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(48.731 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_498",
    "data-name": "Fill 498",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_500",
    "data-name": "Fill 500",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_502",
    "data-name": "Fill 502",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_504",
    "data-name": "Fill 504",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_506",
    "data-name": "Fill 506",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_508",
    "data-name": "Fill 508",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_510",
    "data-name": "Fill 510",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_512",
    "data-name": "Fill 512",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_514",
    "data-name": "Fill 514",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_516",
    "data-name": "Fill 516",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_518",
    "data-name": "Fill 518",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_520",
    "data-name": "Fill 520",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_522",
    "data-name": "Fill 522",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(211.156 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_524",
    "data-name": "Fill 524",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_526",
    "data-name": "Fill 526",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_528",
    "data-name": "Fill 528",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_530",
    "data-name": "Fill 530",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_532",
    "data-name": "Fill 532",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_534",
    "data-name": "Fill 534",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_536",
    "data-name": "Fill 536",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_538",
    "data-name": "Fill 538",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_540",
    "data-name": "Fill 540",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_542",
    "data-name": "Fill 542",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_544",
    "data-name": "Fill 544",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_546",
    "data-name": "Fill 546",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_548",
    "data-name": "Fill 548",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_550",
    "data-name": "Fill 550",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_552",
    "data-name": "Fill 552",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_554",
    "data-name": "Fill 554",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_556",
    "data-name": "Fill 556",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_558",
    "data-name": "Fill 558",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_560",
    "data-name": "Fill 560",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_562",
    "data-name": "Fill 562",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_564",
    "data-name": "Fill 564",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_566",
    "data-name": "Fill 566",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_568",
    "data-name": "Fill 568",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_570",
    "data-name": "Fill 570",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_572",
    "data-name": "Fill 572",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_574",
    "data-name": "Fill 574",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_576",
    "data-name": "Fill 576",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(503.527 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_578",
    "data-name": "Fill 578",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(511.651 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_580",
    "data-name": "Fill 580",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(519.774 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_582",
    "data-name": "Fill 582",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(527.892 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_584",
    "data-name": "Fill 584",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(536.016 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_586",
    "data-name": "Fill 586",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(544.134 113.973)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_588",
    "data-name": "Fill 588",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(8.124 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_590",
    "data-name": "Fill 590",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(16.242 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_592",
    "data-name": "Fill 592",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(24.366 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_594",
    "data-name": "Fill 594",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(32.489 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_596",
    "data-name": "Fill 596",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(40.607 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_598",
    "data-name": "Fill 598",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(48.731 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_600",
    "data-name": "Fill 600",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_602",
    "data-name": "Fill 602",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_604",
    "data-name": "Fill 604",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_606",
    "data-name": "Fill 606",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_608",
    "data-name": "Fill 608",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_610",
    "data-name": "Fill 610",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_612",
    "data-name": "Fill 612",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_614",
    "data-name": "Fill 614",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_616",
    "data-name": "Fill 616",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_618",
    "data-name": "Fill 618",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_620",
    "data-name": "Fill 620",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_622",
    "data-name": "Fill 622",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_624",
    "data-name": "Fill 624",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_626",
    "data-name": "Fill 626",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_628",
    "data-name": "Fill 628",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(235.521 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_630",
    "data-name": "Fill 630",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_632",
    "data-name": "Fill 632",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_634",
    "data-name": "Fill 634",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_636",
    "data-name": "Fill 636",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_638",
    "data-name": "Fill 638",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_640",
    "data-name": "Fill 640",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_642",
    "data-name": "Fill 642",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_644",
    "data-name": "Fill 644",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_646",
    "data-name": "Fill 646",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_648",
    "data-name": "Fill 648",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_650",
    "data-name": "Fill 650",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_652",
    "data-name": "Fill 652",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_654",
    "data-name": "Fill 654",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_656",
    "data-name": "Fill 656",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_658",
    "data-name": "Fill 658",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_660",
    "data-name": "Fill 660",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_662",
    "data-name": "Fill 662",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_664",
    "data-name": "Fill 664",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_666",
    "data-name": "Fill 666",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_668",
    "data-name": "Fill 668",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_670",
    "data-name": "Fill 670",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_672",
    "data-name": "Fill 672",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_674",
    "data-name": "Fill 674",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_676",
    "data-name": "Fill 676",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_678",
    "data-name": "Fill 678",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_680",
    "data-name": "Fill 680",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(503.527 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_682",
    "data-name": "Fill 682",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(511.651 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_684",
    "data-name": "Fill 684",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(519.774 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_686",
    "data-name": "Fill 686",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(527.892 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_688",
    "data-name": "Fill 688",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(536.016 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_690",
    "data-name": "Fill 690",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(544.134 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_692",
    "data-name": "Fill 692",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(552.258 122.117)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(560.382 122.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_695-2",
    "data-name": "Clip 695",
    d: "M0,0H6V6.017H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_696-2",
    "data-name": "Group 696",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_694",
    "data-name": "Fill 694",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_697",
    "data-name": "Fill 697",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(8.124 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_699",
    "data-name": "Fill 699",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(16.242 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_701",
    "data-name": "Fill 701",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(24.366 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_703",
    "data-name": "Fill 703",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(32.489 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_705",
    "data-name": "Fill 705",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(40.607 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_707",
    "data-name": "Fill 707",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(48.731 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_709",
    "data-name": "Fill 709",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_711",
    "data-name": "Fill 711",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_713",
    "data-name": "Fill 713",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_715",
    "data-name": "Fill 715",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_717",
    "data-name": "Fill 717",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_719",
    "data-name": "Fill 719",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_721",
    "data-name": "Fill 721",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_723",
    "data-name": "Fill 723",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_725",
    "data-name": "Fill 725",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_727",
    "data-name": "Fill 727",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_729",
    "data-name": "Fill 729",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_731",
    "data-name": "Fill 731",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_733",
    "data-name": "Fill 733",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_735",
    "data-name": "Fill 735",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_737",
    "data-name": "Fill 737",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(227.403 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_739",
    "data-name": "Fill 739",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_741",
    "data-name": "Fill 741",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_743",
    "data-name": "Fill 743",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_745",
    "data-name": "Fill 745",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_747",
    "data-name": "Fill 747",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_749",
    "data-name": "Fill 749",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_751",
    "data-name": "Fill 751",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_753",
    "data-name": "Fill 753",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_755",
    "data-name": "Fill 755",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_757",
    "data-name": "Fill 757",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_759",
    "data-name": "Fill 759",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_761",
    "data-name": "Fill 761",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_763",
    "data-name": "Fill 763",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_765",
    "data-name": "Fill 765",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_767",
    "data-name": "Fill 767",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_769",
    "data-name": "Fill 769",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_771",
    "data-name": "Fill 771",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_773",
    "data-name": "Fill 773",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_775",
    "data-name": "Fill 775",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_777",
    "data-name": "Fill 777",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_779",
    "data-name": "Fill 779",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_781",
    "data-name": "Fill 781",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_783",
    "data-name": "Fill 783",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_785",
    "data-name": "Fill 785",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_787",
    "data-name": "Fill 787",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_789",
    "data-name": "Fill 789",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_791",
    "data-name": "Fill 791",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_793",
    "data-name": "Fill 793",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_795",
    "data-name": "Fill 795",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(503.527 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_797",
    "data-name": "Fill 797",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(511.651 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_799",
    "data-name": "Fill 799",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(519.774 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_801",
    "data-name": "Fill 801",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(527.892 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_803",
    "data-name": "Fill 803",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(536.016 130.26)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807",
    transform: "translate(0 138.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip_806-2",
    "data-name": "Clip 806",
    d: "M0,0H6V6.017H0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_807-2",
    "data-name": "Group 807",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_805",
    "data-name": "Fill 805",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(0)",
    fill: "#868686"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill_808",
    "data-name": "Fill 808",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(8.124 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_810",
    "data-name": "Fill 810",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(16.242 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_812",
    "data-name": "Fill 812",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(24.366 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_814",
    "data-name": "Fill 814",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(32.489 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_816",
    "data-name": "Fill 816",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(40.607 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_818",
    "data-name": "Fill 818",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(48.731 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_820",
    "data-name": "Fill 820",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_822",
    "data-name": "Fill 822",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_824",
    "data-name": "Fill 824",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_826",
    "data-name": "Fill 826",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_828",
    "data-name": "Fill 828",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_830",
    "data-name": "Fill 830",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_832",
    "data-name": "Fill 832",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_834",
    "data-name": "Fill 834",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_836",
    "data-name": "Fill 836",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_838",
    "data-name": "Fill 838",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_840",
    "data-name": "Fill 840",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_842",
    "data-name": "Fill 842",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_844",
    "data-name": "Fill 844",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_846",
    "data-name": "Fill 846",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_848",
    "data-name": "Fill 848",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_850",
    "data-name": "Fill 850",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_852",
    "data-name": "Fill 852",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_854",
    "data-name": "Fill 854",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_856",
    "data-name": "Fill 856",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_858",
    "data-name": "Fill 858",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_860",
    "data-name": "Fill 860",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_862",
    "data-name": "Fill 862",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_864",
    "data-name": "Fill 864",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_866",
    "data-name": "Fill 866",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_868",
    "data-name": "Fill 868",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_870",
    "data-name": "Fill 870",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_872",
    "data-name": "Fill 872",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_874",
    "data-name": "Fill 874",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_876",
    "data-name": "Fill 876",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_878",
    "data-name": "Fill 878",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_880",
    "data-name": "Fill 880",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_882",
    "data-name": "Fill 882",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_884",
    "data-name": "Fill 884",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_886",
    "data-name": "Fill 886",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_888",
    "data-name": "Fill 888",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_890",
    "data-name": "Fill 890",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_892",
    "data-name": "Fill 892",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_894",
    "data-name": "Fill 894",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(503.527 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_896",
    "data-name": "Fill 896",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(511.651 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_898",
    "data-name": "Fill 898",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(527.892 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_900",
    "data-name": "Fill 900",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(536.016 138.398)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_902",
    "data-name": "Fill 902",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(8.124 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_904",
    "data-name": "Fill 904",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(40.607 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_906",
    "data-name": "Fill 906",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(48.731 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_908",
    "data-name": "Fill 908",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_910",
    "data-name": "Fill 910",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_912",
    "data-name": "Fill 912",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_914",
    "data-name": "Fill 914",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_916",
    "data-name": "Fill 916",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_918",
    "data-name": "Fill 918",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_920",
    "data-name": "Fill 920",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_922",
    "data-name": "Fill 922",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_924",
    "data-name": "Fill 924",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_926",
    "data-name": "Fill 926",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_928",
    "data-name": "Fill 928",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_930",
    "data-name": "Fill 930",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_932",
    "data-name": "Fill 932",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_934",
    "data-name": "Fill 934",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_936",
    "data-name": "Fill 936",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_938",
    "data-name": "Fill 938",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_940",
    "data-name": "Fill 940",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_942",
    "data-name": "Fill 942",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_944",
    "data-name": "Fill 944",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_946",
    "data-name": "Fill 946",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_948",
    "data-name": "Fill 948",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_950",
    "data-name": "Fill 950",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_952",
    "data-name": "Fill 952",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_954",
    "data-name": "Fill 954",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_956",
    "data-name": "Fill 956",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_958",
    "data-name": "Fill 958",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_960",
    "data-name": "Fill 960",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_962",
    "data-name": "Fill 962",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_964",
    "data-name": "Fill 964",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_966",
    "data-name": "Fill 966",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_968",
    "data-name": "Fill 968",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_970",
    "data-name": "Fill 970",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_972",
    "data-name": "Fill 972",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_974",
    "data-name": "Fill 974",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_976",
    "data-name": "Fill 976",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_978",
    "data-name": "Fill 978",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_980",
    "data-name": "Fill 980",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_982",
    "data-name": "Fill 982",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(503.527 146.541)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_984",
    "data-name": "Fill 984",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(48.731 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_986",
    "data-name": "Fill 986",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_988",
    "data-name": "Fill 988",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_990",
    "data-name": "Fill 990",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_992",
    "data-name": "Fill 992",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_994",
    "data-name": "Fill 994",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_996",
    "data-name": "Fill 996",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_998",
    "data-name": "Fill 998",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1000",
    "data-name": "Fill 1000",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1002",
    "data-name": "Fill 1002",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1004",
    "data-name": "Fill 1004",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1006",
    "data-name": "Fill 1006",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1008",
    "data-name": "Fill 1008",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1010",
    "data-name": "Fill 1010",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1012",
    "data-name": "Fill 1012",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1014",
    "data-name": "Fill 1014",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1016",
    "data-name": "Fill 1016",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1018",
    "data-name": "Fill 1018",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1020",
    "data-name": "Fill 1020",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1022",
    "data-name": "Fill 1022",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1024",
    "data-name": "Fill 1024",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1026",
    "data-name": "Fill 1026",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1028",
    "data-name": "Fill 1028",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1030",
    "data-name": "Fill 1030",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1032",
    "data-name": "Fill 1032",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1034",
    "data-name": "Fill 1034",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1036",
    "data-name": "Fill 1036",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1038",
    "data-name": "Fill 1038",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1040",
    "data-name": "Fill 1040",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1042",
    "data-name": "Fill 1042",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1044",
    "data-name": "Fill 1044",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1046",
    "data-name": "Fill 1046",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1048",
    "data-name": "Fill 1048",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1050",
    "data-name": "Fill 1050",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1052",
    "data-name": "Fill 1052",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1054",
    "data-name": "Fill 1054",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1056",
    "data-name": "Fill 1056",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1058",
    "data-name": "Fill 1058",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1060",
    "data-name": "Fill 1060",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(511.651 154.679)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1062",
    "data-name": "Fill 1062",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(48.731 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1064",
    "data-name": "Fill 1064",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1066",
    "data-name": "Fill 1066",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1068",
    "data-name": "Fill 1068",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1070",
    "data-name": "Fill 1070",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1072",
    "data-name": "Fill 1072",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1074",
    "data-name": "Fill 1074",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1076",
    "data-name": "Fill 1076",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1078",
    "data-name": "Fill 1078",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1080",
    "data-name": "Fill 1080",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1082",
    "data-name": "Fill 1082",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1084",
    "data-name": "Fill 1084",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1086",
    "data-name": "Fill 1086",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1088",
    "data-name": "Fill 1088",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1090",
    "data-name": "Fill 1090",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1092",
    "data-name": "Fill 1092",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1094",
    "data-name": "Fill 1094",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1096",
    "data-name": "Fill 1096",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1098",
    "data-name": "Fill 1098",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1100",
    "data-name": "Fill 1100",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1102",
    "data-name": "Fill 1102",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1104",
    "data-name": "Fill 1104",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1106",
    "data-name": "Fill 1106",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1108",
    "data-name": "Fill 1108",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1110",
    "data-name": "Fill 1110",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1112",
    "data-name": "Fill 1112",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1114",
    "data-name": "Fill 1114",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1116",
    "data-name": "Fill 1116",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1118",
    "data-name": "Fill 1118",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1120",
    "data-name": "Fill 1120",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1122",
    "data-name": "Fill 1122",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1124",
    "data-name": "Fill 1124",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1126",
    "data-name": "Fill 1126",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1128",
    "data-name": "Fill 1128",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1130",
    "data-name": "Fill 1130",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1132",
    "data-name": "Fill 1132",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1134",
    "data-name": "Fill 1134",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1136",
    "data-name": "Fill 1136",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1138",
    "data-name": "Fill 1138",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1140",
    "data-name": "Fill 1140",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1142",
    "data-name": "Fill 1142",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1144",
    "data-name": "Fill 1144",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(511.651 162.822)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1146",
    "data-name": "Fill 1146",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(56.849 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1148",
    "data-name": "Fill 1148",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1150",
    "data-name": "Fill 1150",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1152",
    "data-name": "Fill 1152",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1154",
    "data-name": "Fill 1154",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1156",
    "data-name": "Fill 1156",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1158",
    "data-name": "Fill 1158",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1160",
    "data-name": "Fill 1160",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1162",
    "data-name": "Fill 1162",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1164",
    "data-name": "Fill 1164",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1166",
    "data-name": "Fill 1166",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1168",
    "data-name": "Fill 1168",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1170",
    "data-name": "Fill 1170",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1172",
    "data-name": "Fill 1172",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1174",
    "data-name": "Fill 1174",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1176",
    "data-name": "Fill 1176",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1178",
    "data-name": "Fill 1178",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1180",
    "data-name": "Fill 1180",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1182",
    "data-name": "Fill 1182",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1184",
    "data-name": "Fill 1184",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1186",
    "data-name": "Fill 1186",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1188",
    "data-name": "Fill 1188",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1190",
    "data-name": "Fill 1190",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1192",
    "data-name": "Fill 1192",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1194",
    "data-name": "Fill 1194",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1196",
    "data-name": "Fill 1196",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1198",
    "data-name": "Fill 1198",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1200",
    "data-name": "Fill 1200",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1202",
    "data-name": "Fill 1202",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1204",
    "data-name": "Fill 1204",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1206",
    "data-name": "Fill 1206",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1208",
    "data-name": "Fill 1208",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1210",
    "data-name": "Fill 1210",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1212",
    "data-name": "Fill 1212",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1214",
    "data-name": "Fill 1214",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1216",
    "data-name": "Fill 1216",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1218",
    "data-name": "Fill 1218",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1220",
    "data-name": "Fill 1220",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1222",
    "data-name": "Fill 1222",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1224",
    "data-name": "Fill 1224",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1226",
    "data-name": "Fill 1226",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1228",
    "data-name": "Fill 1228",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1230",
    "data-name": "Fill 1230",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 170.96)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1232",
    "data-name": "Fill 1232",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1234",
    "data-name": "Fill 1234",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1236",
    "data-name": "Fill 1236",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1238",
    "data-name": "Fill 1238",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1240",
    "data-name": "Fill 1240",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1242",
    "data-name": "Fill 1242",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1244",
    "data-name": "Fill 1244",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1246",
    "data-name": "Fill 1246",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1248",
    "data-name": "Fill 1248",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1250",
    "data-name": "Fill 1250",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1252",
    "data-name": "Fill 1252",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1254",
    "data-name": "Fill 1254",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1256",
    "data-name": "Fill 1256",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1258",
    "data-name": "Fill 1258",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1260",
    "data-name": "Fill 1260",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1262",
    "data-name": "Fill 1262",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1264",
    "data-name": "Fill 1264",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1266",
    "data-name": "Fill 1266",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1268",
    "data-name": "Fill 1268",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1270",
    "data-name": "Fill 1270",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1272",
    "data-name": "Fill 1272",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1274",
    "data-name": "Fill 1274",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1276",
    "data-name": "Fill 1276",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1278",
    "data-name": "Fill 1278",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1280",
    "data-name": "Fill 1280",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1282",
    "data-name": "Fill 1282",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1284",
    "data-name": "Fill 1284",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1286",
    "data-name": "Fill 1286",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1288",
    "data-name": "Fill 1288",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1290",
    "data-name": "Fill 1290",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1292",
    "data-name": "Fill 1292",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1294",
    "data-name": "Fill 1294",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1296",
    "data-name": "Fill 1296",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1298",
    "data-name": "Fill 1298",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1300",
    "data-name": "Fill 1300",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1302",
    "data-name": "Fill 1302",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1304",
    "data-name": "Fill 1304",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1306",
    "data-name": "Fill 1306",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1308",
    "data-name": "Fill 1308",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1310",
    "data-name": "Fill 1310",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 179.104)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1312",
    "data-name": "Fill 1312",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1314",
    "data-name": "Fill 1314",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1316",
    "data-name": "Fill 1316",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1318",
    "data-name": "Fill 1318",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1320",
    "data-name": "Fill 1320",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1322",
    "data-name": "Fill 1322",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1324",
    "data-name": "Fill 1324",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1326",
    "data-name": "Fill 1326",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1328",
    "data-name": "Fill 1328",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1330",
    "data-name": "Fill 1330",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1332",
    "data-name": "Fill 1332",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1334",
    "data-name": "Fill 1334",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1336",
    "data-name": "Fill 1336",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1338",
    "data-name": "Fill 1338",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1340",
    "data-name": "Fill 1340",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1342",
    "data-name": "Fill 1342",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1344",
    "data-name": "Fill 1344",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1346",
    "data-name": "Fill 1346",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1348",
    "data-name": "Fill 1348",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1350",
    "data-name": "Fill 1350",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1352",
    "data-name": "Fill 1352",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1354",
    "data-name": "Fill 1354",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1356",
    "data-name": "Fill 1356",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1358",
    "data-name": "Fill 1358",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1360",
    "data-name": "Fill 1360",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1362",
    "data-name": "Fill 1362",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1364",
    "data-name": "Fill 1364",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1366",
    "data-name": "Fill 1366",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1368",
    "data-name": "Fill 1368",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1370",
    "data-name": "Fill 1370",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1372",
    "data-name": "Fill 1372",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1374",
    "data-name": "Fill 1374",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1376",
    "data-name": "Fill 1376",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1378",
    "data-name": "Fill 1378",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1380",
    "data-name": "Fill 1380",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1382",
    "data-name": "Fill 1382",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1384",
    "data-name": "Fill 1384",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 187.247)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1386",
    "data-name": "Fill 1386",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(64.973 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1388",
    "data-name": "Fill 1388",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1390",
    "data-name": "Fill 1390",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1392",
    "data-name": "Fill 1392",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1394",
    "data-name": "Fill 1394",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1396",
    "data-name": "Fill 1396",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1398",
    "data-name": "Fill 1398",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1400",
    "data-name": "Fill 1400",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1402",
    "data-name": "Fill 1402",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1404",
    "data-name": "Fill 1404",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1406",
    "data-name": "Fill 1406",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1408",
    "data-name": "Fill 1408",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1410",
    "data-name": "Fill 1410",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1412",
    "data-name": "Fill 1412",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1414",
    "data-name": "Fill 1414",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1416",
    "data-name": "Fill 1416",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1418",
    "data-name": "Fill 1418",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1420",
    "data-name": "Fill 1420",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1422",
    "data-name": "Fill 1422",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1424",
    "data-name": "Fill 1424",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1426",
    "data-name": "Fill 1426",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1428",
    "data-name": "Fill 1428",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1430",
    "data-name": "Fill 1430",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1432",
    "data-name": "Fill 1432",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1434",
    "data-name": "Fill 1434",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1436",
    "data-name": "Fill 1436",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1438",
    "data-name": "Fill 1438",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1440",
    "data-name": "Fill 1440",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1442",
    "data-name": "Fill 1442",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1444",
    "data-name": "Fill 1444",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1446",
    "data-name": "Fill 1446",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 195.385)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1448",
    "data-name": "Fill 1448",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(73.097 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1450",
    "data-name": "Fill 1450",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1452",
    "data-name": "Fill 1452",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1454",
    "data-name": "Fill 1454",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1456",
    "data-name": "Fill 1456",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1458",
    "data-name": "Fill 1458",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1460",
    "data-name": "Fill 1460",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1462",
    "data-name": "Fill 1462",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1464",
    "data-name": "Fill 1464",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1466",
    "data-name": "Fill 1466",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1468",
    "data-name": "Fill 1468",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1470",
    "data-name": "Fill 1470",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1472",
    "data-name": "Fill 1472",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1474",
    "data-name": "Fill 1474",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1476",
    "data-name": "Fill 1476",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1478",
    "data-name": "Fill 1478",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1480",
    "data-name": "Fill 1480",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1482",
    "data-name": "Fill 1482",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1484",
    "data-name": "Fill 1484",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1486",
    "data-name": "Fill 1486",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1488",
    "data-name": "Fill 1488",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1490",
    "data-name": "Fill 1490",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1492",
    "data-name": "Fill 1492",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1494",
    "data-name": "Fill 1494",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1496",
    "data-name": "Fill 1496",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1498",
    "data-name": "Fill 1498",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1500",
    "data-name": "Fill 1500",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1502",
    "data-name": "Fill 1502",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1504",
    "data-name": "Fill 1504",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1506",
    "data-name": "Fill 1506",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1508",
    "data-name": "Fill 1508",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1510",
    "data-name": "Fill 1510",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1512",
    "data-name": "Fill 1512",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 203.528)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1514",
    "data-name": "Fill 1514",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1516",
    "data-name": "Fill 1516",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1518",
    "data-name": "Fill 1518",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1520",
    "data-name": "Fill 1520",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1522",
    "data-name": "Fill 1522",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1524",
    "data-name": "Fill 1524",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1526",
    "data-name": "Fill 1526",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(243.645 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1528",
    "data-name": "Fill 1528",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1530",
    "data-name": "Fill 1530",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1532",
    "data-name": "Fill 1532",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1534",
    "data-name": "Fill 1534",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1536",
    "data-name": "Fill 1536",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1538",
    "data-name": "Fill 1538",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1540",
    "data-name": "Fill 1540",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1542",
    "data-name": "Fill 1542",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1544",
    "data-name": "Fill 1544",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1546",
    "data-name": "Fill 1546",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1548",
    "data-name": "Fill 1548",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1550",
    "data-name": "Fill 1550",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1552",
    "data-name": "Fill 1552",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1554",
    "data-name": "Fill 1554",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1556",
    "data-name": "Fill 1556",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1558",
    "data-name": "Fill 1558",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1560",
    "data-name": "Fill 1560",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1562",
    "data-name": "Fill 1562",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1564",
    "data-name": "Fill 1564",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1566",
    "data-name": "Fill 1566",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1568",
    "data-name": "Fill 1568",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1570",
    "data-name": "Fill 1570",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1572",
    "data-name": "Fill 1572",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1574",
    "data-name": "Fill 1574",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1576",
    "data-name": "Fill 1576",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 211.666)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1578",
    "data-name": "Fill 1578",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(81.215 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1580",
    "data-name": "Fill 1580",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(89.339 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1582",
    "data-name": "Fill 1582",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1584",
    "data-name": "Fill 1584",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1586",
    "data-name": "Fill 1586",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(243.645 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1588",
    "data-name": "Fill 1588",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1590",
    "data-name": "Fill 1590",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1592",
    "data-name": "Fill 1592",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1594",
    "data-name": "Fill 1594",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1596",
    "data-name": "Fill 1596",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1598",
    "data-name": "Fill 1598",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1600",
    "data-name": "Fill 1600",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1602",
    "data-name": "Fill 1602",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1604",
    "data-name": "Fill 1604",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1606",
    "data-name": "Fill 1606",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1608",
    "data-name": "Fill 1608",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1610",
    "data-name": "Fill 1610",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(357.344 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1612",
    "data-name": "Fill 1612",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(365.468 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1614",
    "data-name": "Fill 1614",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1616",
    "data-name": "Fill 1616",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1618",
    "data-name": "Fill 1618",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1620",
    "data-name": "Fill 1620",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1622",
    "data-name": "Fill 1622",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1624",
    "data-name": "Fill 1624",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1626",
    "data-name": "Fill 1626",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1628",
    "data-name": "Fill 1628",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1630",
    "data-name": "Fill 1630",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1632",
    "data-name": "Fill 1632",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 219.809)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1634",
    "data-name": "Fill 1634",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(97.457 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1636",
    "data-name": "Fill 1636",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(129.946 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1638",
    "data-name": "Fill 1638",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(235.521 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1640",
    "data-name": "Fill 1640",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(243.645 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1642",
    "data-name": "Fill 1642",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1644",
    "data-name": "Fill 1644",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1646",
    "data-name": "Fill 1646",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1648",
    "data-name": "Fill 1648",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1650",
    "data-name": "Fill 1650",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1652",
    "data-name": "Fill 1652",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1654",
    "data-name": "Fill 1654",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1656",
    "data-name": "Fill 1656",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1658",
    "data-name": "Fill 1658",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1660",
    "data-name": "Fill 1660",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1662",
    "data-name": "Fill 1662",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1664",
    "data-name": "Fill 1664",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1666",
    "data-name": "Fill 1666",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(349.22 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1668",
    "data-name": "Fill 1668",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(373.586 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1670",
    "data-name": "Fill 1670",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1672",
    "data-name": "Fill 1672",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1674",
    "data-name": "Fill 1674",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(397.952 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1676",
    "data-name": "Fill 1676",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(406.07 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1678",
    "data-name": "Fill 1678",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1680",
    "data-name": "Fill 1680",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1682",
    "data-name": "Fill 1682",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1684",
    "data-name": "Fill 1684",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 227.953)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1686",
    "data-name": "Fill 1686",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(105.581 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1688",
    "data-name": "Fill 1688",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(113.699 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1690",
    "data-name": "Fill 1690",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(235.521 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1692",
    "data-name": "Fill 1692",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(243.645 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1694",
    "data-name": "Fill 1694",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1696",
    "data-name": "Fill 1696",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1698",
    "data-name": "Fill 1698",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1700",
    "data-name": "Fill 1700",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1702",
    "data-name": "Fill 1702",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1704",
    "data-name": "Fill 1704",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1706",
    "data-name": "Fill 1706",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1708",
    "data-name": "Fill 1708",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1710",
    "data-name": "Fill 1710",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1712",
    "data-name": "Fill 1712",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1714",
    "data-name": "Fill 1714",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(341.102 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1716",
    "data-name": "Fill 1716",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1718",
    "data-name": "Fill 1718",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1720",
    "data-name": "Fill 1720",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(414.194 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1722",
    "data-name": "Fill 1722",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 236.09)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1724",
    "data-name": "Fill 1724",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(121.823 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1726",
    "data-name": "Fill 1726",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(235.521 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1728",
    "data-name": "Fill 1728",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(243.645 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1730",
    "data-name": "Fill 1730",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1732",
    "data-name": "Fill 1732",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1734",
    "data-name": "Fill 1734",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1736",
    "data-name": "Fill 1736",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1738",
    "data-name": "Fill 1738",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1740",
    "data-name": "Fill 1740",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1742",
    "data-name": "Fill 1742",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1744",
    "data-name": "Fill 1744",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1746",
    "data-name": "Fill 1746",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1748",
    "data-name": "Fill 1748",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1750",
    "data-name": "Fill 1750",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(381.71 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1752",
    "data-name": "Fill 1752",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1754",
    "data-name": "Fill 1754",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(430.435 244.234)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1756",
    "data-name": "Fill 1756",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1758",
    "data-name": "Fill 1758",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1760",
    "data-name": "Fill 1760",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1762",
    "data-name": "Fill 1762",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1764",
    "data-name": "Fill 1764",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(243.645 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1766",
    "data-name": "Fill 1766",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(251.763 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1768",
    "data-name": "Fill 1768",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(259.887 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1770",
    "data-name": "Fill 1770",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(268.011 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1772",
    "data-name": "Fill 1772",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1774",
    "data-name": "Fill 1774",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1776",
    "data-name": "Fill 1776",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1778",
    "data-name": "Fill 1778",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1780",
    "data-name": "Fill 1780",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1782",
    "data-name": "Fill 1782",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1784",
    "data-name": "Fill 1784",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1786",
    "data-name": "Fill 1786",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1788",
    "data-name": "Fill 1788",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(389.828 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1790",
    "data-name": "Fill 1790",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 252.371)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1792",
    "data-name": "Fill 1792",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1794",
    "data-name": "Fill 1794",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1796",
    "data-name": "Fill 1796",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1798",
    "data-name": "Fill 1798",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1800",
    "data-name": "Fill 1800",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1802",
    "data-name": "Fill 1802",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1804",
    "data-name": "Fill 1804",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1806",
    "data-name": "Fill 1806",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1808",
    "data-name": "Fill 1808",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1810",
    "data-name": "Fill 1810",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1812",
    "data-name": "Fill 1812",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1814",
    "data-name": "Fill 1814",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1816",
    "data-name": "Fill 1816",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(324.86 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1818",
    "data-name": "Fill 1818",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1820",
    "data-name": "Fill 1820",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1822",
    "data-name": "Fill 1822",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 260.515)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1824",
    "data-name": "Fill 1824",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1826",
    "data-name": "Fill 1826",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1828",
    "data-name": "Fill 1828",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1830",
    "data-name": "Fill 1830",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1832",
    "data-name": "Fill 1832",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1834",
    "data-name": "Fill 1834",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1836",
    "data-name": "Fill 1836",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1838",
    "data-name": "Fill 1838",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1840",
    "data-name": "Fill 1840",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(276.129 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1842",
    "data-name": "Fill 1842",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1844",
    "data-name": "Fill 1844",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1846",
    "data-name": "Fill 1846",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1848",
    "data-name": "Fill 1848",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1850",
    "data-name": "Fill 1850",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1852",
    "data-name": "Fill 1852",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(422.317 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1854",
    "data-name": "Fill 1854",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1856",
    "data-name": "Fill 1856",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1858",
    "data-name": "Fill 1858",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 268.653)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1860",
    "data-name": "Fill 1860",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1862",
    "data-name": "Fill 1862",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1864",
    "data-name": "Fill 1864",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1866",
    "data-name": "Fill 1866",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1868",
    "data-name": "Fill 1868",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1870",
    "data-name": "Fill 1870",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1872",
    "data-name": "Fill 1872",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1874",
    "data-name": "Fill 1874",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1876",
    "data-name": "Fill 1876",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(203.038 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1878",
    "data-name": "Fill 1878",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1880",
    "data-name": "Fill 1880",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1882",
    "data-name": "Fill 1882",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1884",
    "data-name": "Fill 1884",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1886",
    "data-name": "Fill 1886",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1888",
    "data-name": "Fill 1888",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(438.559 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1890",
    "data-name": "Fill 1890",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1892",
    "data-name": "Fill 1892",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1894",
    "data-name": "Fill 1894",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 276.796)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1896",
    "data-name": "Fill 1896",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(138.064 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1898",
    "data-name": "Fill 1898",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1900",
    "data-name": "Fill 1900",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1902",
    "data-name": "Fill 1902",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1904",
    "data-name": "Fill 1904",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1906",
    "data-name": "Fill 1906",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1908",
    "data-name": "Fill 1908",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1910",
    "data-name": "Fill 1910",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1912",
    "data-name": "Fill 1912",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1914",
    "data-name": "Fill 1914",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1916",
    "data-name": "Fill 1916",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1918",
    "data-name": "Fill 1918",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1920",
    "data-name": "Fill 1920",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1922",
    "data-name": "Fill 1922",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1924",
    "data-name": "Fill 1924",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 284.94)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1926",
    "data-name": "Fill 1926",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1928",
    "data-name": "Fill 1928",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1930",
    "data-name": "Fill 1930",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1932",
    "data-name": "Fill 1932",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1934",
    "data-name": "Fill 1934",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1936",
    "data-name": "Fill 1936",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1938",
    "data-name": "Fill 1938",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(194.914 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1940",
    "data-name": "Fill 1940",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1942",
    "data-name": "Fill 1942",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1944",
    "data-name": "Fill 1944",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1946",
    "data-name": "Fill 1946",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1948",
    "data-name": "Fill 1948",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(316.737 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1950",
    "data-name": "Fill 1950",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1952",
    "data-name": "Fill 1952",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1954",
    "data-name": "Fill 1954",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1956",
    "data-name": "Fill 1956",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1958",
    "data-name": "Fill 1958",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1960",
    "data-name": "Fill 1960",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1962",
    "data-name": "Fill 1962",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(544.134 293.077)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1964",
    "data-name": "Fill 1964",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1966",
    "data-name": "Fill 1966",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1968",
    "data-name": "Fill 1968",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1970",
    "data-name": "Fill 1970",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1972",
    "data-name": "Fill 1972",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(186.796 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1974",
    "data-name": "Fill 1974",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1976",
    "data-name": "Fill 1976",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1978",
    "data-name": "Fill 1978",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1980",
    "data-name": "Fill 1980",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1982",
    "data-name": "Fill 1982",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(332.978 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1984",
    "data-name": "Fill 1984",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1986",
    "data-name": "Fill 1986",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1988",
    "data-name": "Fill 1988",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1990",
    "data-name": "Fill 1990",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1992",
    "data-name": "Fill 1992",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1994",
    "data-name": "Fill 1994",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1996",
    "data-name": "Fill 1996",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 301.221)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_1998",
    "data-name": "Fill 1998",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2000",
    "data-name": "Fill 2000",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2002",
    "data-name": "Fill 2002",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2004",
    "data-name": "Fill 2004",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(178.672 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2006",
    "data-name": "Fill 2006",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(284.253 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2008",
    "data-name": "Fill 2008",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2010",
    "data-name": "Fill 2010",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2012",
    "data-name": "Fill 2012",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(308.613 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2014",
    "data-name": "Fill 2014",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2016",
    "data-name": "Fill 2016",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2018",
    "data-name": "Fill 2018",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2020",
    "data-name": "Fill 2020",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2022",
    "data-name": "Fill 2022",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2024",
    "data-name": "Fill 2024",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2026",
    "data-name": "Fill 2026",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2028",
    "data-name": "Fill 2028",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(503.527 309.358)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2030",
    "data-name": "Fill 2030",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2032",
    "data-name": "Fill 2032",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2034",
    "data-name": "Fill 2034",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2036",
    "data-name": "Fill 2036",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(170.554 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2038",
    "data-name": "Fill 2038",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(292.371 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2040",
    "data-name": "Fill 2040",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(300.495 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2042",
    "data-name": "Fill 2042",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(446.677 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2044",
    "data-name": "Fill 2044",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(454.801 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2046",
    "data-name": "Fill 2046",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(462.925 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2048",
    "data-name": "Fill 2048",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(471.043 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2050",
    "data-name": "Fill 2050",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(479.167 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2052",
    "data-name": "Fill 2052",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2054",
    "data-name": "Fill 2054",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 317.502)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2056",
    "data-name": "Fill 2056",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 325.645)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2058",
    "data-name": "Fill 2058",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 325.645)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2060",
    "data-name": "Fill 2060",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(162.43 325.645)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2062",
    "data-name": "Fill 2062",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(487.285 325.645)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2064",
    "data-name": "Fill 2064",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(495.409 325.645)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2066",
    "data-name": "Fill 2066",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 333.783)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2068",
    "data-name": "Fill 2068",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 333.783)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2070",
    "data-name": "Fill 2070",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 341.926)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2072",
    "data-name": "Fill 2072",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 341.926)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2074",
    "data-name": "Fill 2074",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 350.064)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2076",
    "data-name": "Fill 2076",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(154.306 350.064)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2078",
    "data-name": "Fill 2078",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 358.207)",
    fill: "#868686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2080",
    "data-name": "Fill 2080",
    d: "M3,0A3.008,3.008,0,1,1,0,3.009,3,3,0,0,1,3,0",
    transform: "translate(146.188 366.345)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2083",
    "data-name": "Fill 2083",
    d: "M13.1,0A13.1,13.1,0,1,1,0,13.1,13.1,13.1,0,0,1,13.1,0",
    transform: "translate(47.654 121.112)",
    fill: "#c1e9e5",
    opacity: 0.501
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2085",
    "data-name": "Fill 2085",
    d: "M7.148,0A7.148,7.148,0,1,1,0,7.148,7.148,7.148,0,0,1,7.148,0",
    transform: "translate(312.134 150.896)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2087",
    "data-name": "Fill 2087",
    d: "M10.722,0A10.722,10.722,0,1,1,0,10.722,10.722,10.722,0,0,1,10.722,0",
    transform: "translate(89.351 156.853)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2089",
    "data-name": "Fill 2089",
    d: "M2.978,0A2.978,2.978,0,1,1,0,2.979,2.978,2.978,0,0,1,2.978,0",
    transform: "translate(284.733 172.34)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2091",
    "data-name": "Fill 2091",
    d: "M5.957,0A5.957,5.957,0,1,1,0,5.957,5.956,5.956,0,0,1,5.957,0",
    transform: "translate(353.832 193.784)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2093",
    "data-name": "Fill 2093",
    d: "M11.914,0A11.914,11.914,0,1,1,0,11.914,11.914,11.914,0,0,1,11.914,0",
    transform: "translate(430.078 158.044)",
    fill: "#c1e9e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2095",
    "data-name": "Fill 2095",
    d: "M4.765,0A4.765,4.765,0,1,1,0,4.765,4.766,4.766,0,0,1,4.765,0",
    transform: "translate(119.135 130.643)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2097",
    "data-name": "Fill 2097",
    d: "M7.148,0A7.148,7.148,0,1,1,0,7.148,7.148,7.148,0,0,1,7.148,0",
    transform: "translate(370.511 150.896)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2099",
    "data-name": "Fill 2099",
    d: "M4.765,0A4.765,4.765,0,1,1,0,4.765,4.765,4.765,0,0,1,4.765,0",
    transform: "translate(299.03 235.482)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2101",
    "data-name": "Fill 2101",
    d: "M10.722,0A10.722,10.722,0,1,1,0,10.722,10.722,10.722,0,0,1,10.722,0",
    transform: "translate(162.024 285.519)",
    fill: "#c1e9e5",
    opacity: 0.505
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_2103",
    "data-name": "Fill 2103",
    d: "M7.148,0A7.148,7.148,0,1,1,0,7.148,7.149,7.149,0,0,1,7.148,0",
    transform: "translate(465.819 298.624)",
    fill: "#c1e9e5",
    opacity: 0.505
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Feature1.a44fb3b1.svg";
export { ForwardRef as ReactComponent };